/*
 * @Author: redu842 2150673512@qq.com
 * @Date: 2024-07-09 15:47:34
 * @LastEditors: redu842 2150673512@qq.com
 * @LastEditTime: 2024-07-11 18:00:38
 * @FilePath: \wind\src\router\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
/*
 * @Author: redu842 2150673512@qq.com
 * @Date: 2024-07-09 15:47:34
 * @LastEditors: redu842 2150673512@qq.com
 * @LastEditTime: 2024-07-09 15:52:42
 * @FilePath: \wind\src\router\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from "../views/Home"
import DataForecast from "../views/DataForecast"

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
    children: [
      {
        // 当 /user/:id/profile 匹配成功
        // UserProfile 将被渲染到 User 的 <router-view> 内部
        path: '/',
        component: DataForecast,
      },

    ],
  }

]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
